// import brokenGlass from './broken-glass';
import './broken-glass.scss';

document.addEventListener('DOMContentLoaded', () => {
  // we can add only one such effect in page
  // const canvas = document.querySelector('[data-broken-glass-canvas]');
  // if (canvas) {
  //   brokenGlass(document.querySelector('[data-broken-glass-canvas]')).then(() => {
  //     canvas.classList.add('broken-glass_show');
  //     // start other animations on page here
  //   });
  // }
  const mob = window.isMobile.any;

  document.querySelectorAll('video.broken-glass').forEach((video) => {
    const main = $(video).closest('.main')[0];
    const onLoad = () => {
      video.classList.add('broken-glass_show');
      if (main) {
        main.classList.add('animate');
      }
    };
    if (!mob && video.dataset.desktopAutoplay !== undefined) {
      video.addEventListener('canplaythrough', onLoad);
      if (video.readyState > 3) {
        onLoad();
      }
      video.play();
    } else {
      onLoad();
    }
  });
});
